import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class NoAuthGuard implements CanActivate {

    constructor(
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        return new Promise(resolve => {
            this.authService.isLoggedInGuard()
                .then(isLogged => resolve( ! isLogged));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/no-auth.guard.ts